<template>
  <footer class="footer">
    <div class="container">
      <ul>
        <li>
          <h5>解决方案</h5>
          <span @click="$gotoPage('/solution/project')">项目管理</span>
          <span @click="$gotoPage('/solution/development')">研发管理</span>
          <span @click="$gotoPage('/solution/outsourcing')">外包管理</span>
        </li>
        <li>
          <h5>产品</h5>
          <!-- <span @click="$gotoPage('/products/platform')">信创一体化办公平台</span> -->
            <span @click="$gotoPage('/products/operation')">数据运营中台</span>
            <span @click="$gotoPage('/products/blockchain')">区块链联盟链工具平台</span>
            <span @click="$gotoPage('/products/bigdata')">实时大数据工具平台</span>
            <span @click="$gotoPage('/products/hroutsourcing')">人力外包平台</span>
        </li>
        <li>
          <h5>动态</h5>
         <span @click="$gotoPage('/aboutUs/profile')">公司简介</span>
          <span @click="$gotoPage('/aboutUs/advantage')">公司优势</span>
          <span @click="$gotoPage('/aboutUs/qualification')">公司资质</span>
          <span @click="$gotoPage('/aboutUs/news')">公司资讯</span>
          <span @click="$gotoPage('/aboutUs/contact')">联系我们</span>
          <span @click="$gotoPage('/aboutUs/join')">加入我们</span>
        </li>
        <li>
          <h5>服务支持</h5>
          <span @click="$gotoPage('/service/management')">管理咨询</span>
          <span @click="$gotoPage('/service/enterprise')">企业内训</span>
          <span @click="$gotoPage('/service/dev')">应用开发</span>
        </li>
        <li>
          <h5>强强联合</h5>
          <a href="http://www.wiilead.com" target="_black" class="dribble">微荔科技</a>
        </li>
        <li class="ft-info">
          <span><img src="../assets/images/footer/1.png" /> 158-7551-4377</span>
          <span><img src="../assets/images/footer/2.png" /> 10477387</span>
          <span
            ><img src="../assets/images/footer/3.png" /> xiaojing.xue@wiilead.com</span
          >
          <!-- <a href="http://www.buildpmo.com" target="_blank"
            ><img src="../assets/images/footer/4.png" /> www.buildpmo.com</a
          > -->
          <a href="https://beian.miit.gov.cn" target="_blank" style="color: #007bff;"
            ><img src="../assets/images/footer/4.png" /> 粤ICP备18123610号</a
          >
        </li>
        <li class="ft-code">
          <i class="codeImg"></i>
          <p>关注公众号，获取更多资讯</p>
        </li>
      </ul>
      <div class="footer-top-text">
        <p>
          Copyright © 2013 ~ <span id="timeYear">2021</span> Oriental DaTang Information Technology Co.,Ltd.<br />
          广东省深圳市南山区茶光路1018号创客公馆415室<br />
          深圳东方大唐信息技术有限公司
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
